/* eslint-disable import/no-default-export */
import {GalleryController} from '../../viewerScript/GalleryController';

export default GalleryController();
